
/* eslint-disable no-empty-pattern */
import React, { useContext } from 'react'
import pagainationArrow from './../../assets/pagination-arrow.png';
import { StateContext } from '../../Util/StateContext/StateContext';


const Pagination = (props) => {

    const { state, dispatch } = useContext(StateContext);

    let totalNumberofPages = Math.ceil(props.totalNumberofProducts / 100);

    const pages = Array.from(Array(totalNumberofPages).keys());
    const startPage = Math.max(1, state.paged - 2);
    const endPage = Math.min(state.paged + 2, totalNumberofPages);

    const scrollToMissingPartsField = (e) => {
        e.preventDefault();
        dispatch({ type: 'TOGGLE_FORM_DRAWER', payload: !state.formDrawerOpen });
        const formField = document.getElementById('missing_part_numbers');
        // const formDrawer = document.getElementById('form-drawer');
        setTimeout(() => {
            window.scrollTo({ top: formField.offsetTop, behavior: 'smooth' });
            setTimeout(() => {
                formField.focus();
            }, 500);
        }, 500);
        
        
    }



    const PaginationNumberButton = (props) => (
        <button
            aria-label={`Navigate to page ${props.pageNumber}`}
        >
            <span
                className={props.pageNumber === state.paged ? "active" : ""}
                key={props.keys}
                onClick={props.click}>{props.text}</span>
        </button>

    );

    const dispatchNewPageNumber = (pageNumber) => {
        if (pageNumber !== state.paged) {
            dispatch({ type: "SET_PAGED_NUMBER", payload: pageNumber });
            document.querySelector('.scroll-wrapper').scrollTo({ top: 0, behavior: 'smooth' });
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    return (
        <div id="tooling-catalog-pagination">
            <div className="wrapper">
                <button

                    aria-label={`Navigate to first page`}
                    className={state.paged === 1 ? "disabled" : ""}
                    onClick={() => dispatchNewPageNumber(1)}
                    disabled={state.paged === 1 ? true : false}
                >
                    <img alt="Pagination left arrow" src={pagainationArrow} />
                    <img alt="Pagination left arrow" src={pagainationArrow} />
                </button>
                <button
                    aria-label={`Navigate to previous page`}
                    className={state.paged === 1 ? "disabled arrow" : "arrow"}
                    onClick={() => dispatchNewPageNumber(Math.abs(state.paged - 1))}
                    disabled={state.paged === 1 ? true : false}>
                    <img alt="Pagination left arrow" src={pagainationArrow} />
                </button>
                {
                    //TODO: Add logic to center pagnation

                    pages.map((i) => {
                        if (i + 1 <= endPage && i + 1 >= startPage) {
                            return (
                                <PaginationNumberButton
                                    key={i}
                                    text={i + 1}
                                    click={
                                        () => dispatchNewPageNumber(i + 1)
                                    }

                                    pageNumber={i + 1}>
                                </PaginationNumberButton>)

                        }
                        return null;
                    })

                }
                {totalNumberofPages >= endPage + 4 &&
                    <>
                        <span>...</span>
                        <PaginationNumberButton
                            text={endPage + 4}
                            click={
                                () => dispatchNewPageNumber(endPage + 4)
                            }
                            pageNumber={endPage + 4}>
                        </PaginationNumberButton>
                    </>
                }

                <button
                    className={state.paged === totalNumberofPages ? "disabled " : "arrow"}
                    onClick={() => dispatchNewPageNumber(state.paged + 1)}
                    disabled={state.paged === totalNumberofPages ? true : false}
                    aria-label={`Navigate to next page`}
                >
                    <img alt="Pagination right arrow" className="flipped" src={pagainationArrow} />
                </button>
                <button
                    className={state.paged === totalNumberofPages ? "disabled" : ""}
                    onClick={() => dispatchNewPageNumber(pages.length)}
                    disabled={state.paged === totalNumberofPages ? true : false}
                    aria-label={`Navigate to last page`}
                >
                    <img alt="Pagination right arrow" className="flipped" src={pagainationArrow} />
                    <img alt="Pagination right arrow" className="flipped" src={pagainationArrow} />
                </button>
            </div>
            <div id="missing-parts-link">
                <a href="#" onClick={scrollToMissingPartsField} target="_blank" rel="noreferrer">Can't find a part number?</a>
            </div>
        </div>
    )
}

export default Pagination;
